var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeaf = function SvgLeaf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "leaf_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h48v48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#leaf_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#004152"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.384 4.007c.423.046.794.304.984.684 2.04 4.08 4.132 8.642 4.132 16.559 0 11.712-10.142 21.25-21.249 21.25l-.001-1.25.004 1.25h-.003a15.25 15.25 0 0 1-2.638-30.277l.237 1.227-.21-1.232-.014.002c5.717-1.103 9.177-1.892 11.704-2.983 2.441-1.054 4.038-2.404 5.947-4.772a1.25 1.25 0 0 1 1.107-.458Zm-6.063 7.526c-2.822 1.218-6.56 2.05-12.234 3.144l-.026.005A12.75 12.75 0 0 0 23.245 40h.004C33.022 40 42 31.537 42 21.25c0-6.316-1.404-10.273-3.04-13.745-1.644 1.777-3.323 3.027-5.64 4.028Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.134 24.366a1.25 1.25 0 0 1 0 1.768c-1.114 1.114-2.976 2.442-5.148 3.607-2.18 1.171-4.76 2.225-7.333 2.735C9.77 33.642 6.5 37.856 6.5 43.25a1.25 1.25 0 1 1-2.5 0c0-6.606 4.131-11.832 11.167-13.226 2.266-.45 4.608-1.396 6.637-2.485 2.038-1.095 3.676-2.287 4.562-3.173a1.25 1.25 0 0 1 1.768 0Z"
  }))));
};
export default SvgLeaf;